import { createSlice } from "@reduxjs/toolkit";
import { fetchNotificationSummaryThunk, readAllNotificationsThunk } from "./notificationThunks";

const initialState = {
  summary: {
    kyc: 0,
    new_account: 0,
    deposit: 0,
    withdraw: 0,
    total: 0,
  },
  loading: false,
  summaryLoading: false,
  error: null
};

const notificationSlice = createSlice({
    name: "notification",
    initialState,
    reducers: {
        clearNotificationError(state) {
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        builder
            // Fetch Summary
            .addCase(fetchNotificationSummaryThunk.pending, (state) => {
                state.summaryLoading = true;
                state.error = null;
            })
            // .addCase(fetchNotificationSummaryThunk.fulfilled, (state, action) => {
            //     state.summaryLoading = false;
            //     state.summary = {
            //         ...state.summary,
            //         ...action.payload
            //     };
            // })
            .addCase(fetchNotificationSummaryThunk.fulfilled, (state, action) => {
                state.summaryLoading = false;
                state.summary = action.payload; // direct replace
            })
            .addCase(fetchNotificationSummaryThunk.rejected, (state, action) => {
                state.summaryLoading = false;
                state.error = action.payload || action.error?.message || "Failed to fetch notification summary";
                // Note: state.summary is preserved (not reset to zero) on failure
            })
            
            // Read All / Read Type
            .addCase(readAllNotificationsThunk.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(readAllNotificationsThunk.fulfilled, (state) => {
                state.loading = false;
            })
            .addCase(readAllNotificationsThunk.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error?.message || "Failed to update notification status";
            });
    }
});

export const { clearNotificationError } = notificationSlice.actions;
export default notificationSlice.reducer;